const defaultname = 'default_1'

/**
 * 添加全局组件
 * @param {*} component 
 */
export const addComponent = (component) => {
    component.install = function(Vue) {
        Vue.component(component.name === defaultname ? component.options.name : component.name, component)
    }
    return component
}

/**
 * 批量导出全局组件
 * @param {*} components 
 */
export const batchExportComponents = (components) => ({
    install: (Vue, opts = {}) => {
        Object.keys(components).map(componentName => {
            let comp = components[componentName]
            Vue.component(comp.name !== defaultname 
                ? comp.name 
                : comp.options.name !== defaultname 
                    ? comp.options.name
                    : componentName, comp)
        })

        Vue.prototype.$PUBLIC = {
            size: opts.size || '',
            zIndex: opts.zIndex || 2000
        }
    }
})

// 事件的绑定（兼容）
// W3C addEventListener
// IE attachEvent
export const bindEvent = (obj, type, fn, bubble = false) => {
    !Array.isArray(obj) && (obj = [obj])
    obj.forEach(element => {
        // 2.	开始判断浏览器
        if (typeof element.addEventListener != 'undefined') {
            element.addEventListener(type, fn, bubble) // W3C
        } else if (typeof element.attachEvent != 'undefined') {
            element.attachEvent('on'+type, fn) // IE
        } else {
            element["on" + type] = fn
        }
    })
    return obj
}

/**
 * 批量绑定事件
 * @param {*} obj 
 * @param {*} types 
 * @param {*} fn 
 * @param {*} bubble 
 */
export const bindEvents = (obj, types, fn, bubble = false) => {
    if (typeof types !== 'object') return bindEvent(obj, types, fn, bubble)
    for (let key in types) {
        bindEvent(obj, key, types[key], typeof fn !== 'function' ? fn : bubble)
    }
    return obj
}

export const offset = (obj) => {
    let offset = { top: 0, left : 0 }
    if (typeof obj !== 'object') return offset
    offset = { top: obj.offsetTop || 0, left: obj.offsetLeft || 0 }
    while (obj = obj.offsetParent || false) { 
        offset.top += obj.offsetTop
        offset.left += obj.offsetLeft
    }
    return offset
}

export const scroll = (obj) => {
    let offset = { top: 0, left : 0 }
    if (typeof obj !== 'object') return offset
    offset = { top: obj.scrollTop || 0, left: obj.scrollLeft || 0 }
    return offset
}


export const width = (obj, fn) => {
    let width = parseInt(css(obj, 'width')) || 0
    if (isNaN(width)) width = 0
    return typeof fn === 'function' ? fn.call(obj, width) : width
}

export const height = (obj, fn) => {
    let height = parseInt(css(obj, 'height')) || 0
    if (isNaN(height)) height = 0
    return typeof fn === 'function' ? fn.call(obj, height) : height
}

export const css = (obj, style, value) => {
    if (!obj) return obj
    let rupper = /([A-Z]|^ms)/g
    if (Array.isArray(obj)) {
        let vms = new Array()
        for (let vm of obj) {
            vms.push(css(vm, style, value))
        }
        return vms.length === 1 ? vms[0] : vms
    }
    if (!Array.isArray(style) && new Object(style) === style) {
        if (value === true || !Object.keys(style).length) (obj.$el ? obj.$el : obj).removeAttribute('style')
        for (let key in style) {
            let val = style[key]
            key = key.replace(rupper, "-$1").toLowerCase()
            if (obj.$el) {
                obj.$el.style[key] = val
                continue
            }
            obj.style[key] = val
        }

    } else if (Array.isArray(style)) {
        let styleVal = {}
        for (let key in style) {
            if (typeof style[key] !== 'string') continue
            style[key] = style[key].replace(rupper, "-$1").toLowerCase();
            let val = obj.style[style[key]]
            styleVal[style[key]] = val ? val : getStyle(obj, style[key])
        }
        return styleVal
    } else if (typeof style === 'string') {
        style = style.replace(rupper, "-$1").toLowerCase();
        if (value === undefined) {
            let val = obj.style[style]
            return val ? val : getStyle(obj, style)
        }
        if (obj.$el) {
            obj.$el.style[style] = value
        } else {
            obj.style[style] = value
        }   
    }
    return obj
}

export const getStyle = (obj, attr) => {  
    if(window.getComputedStyle) {  
        return window.getComputedStyle(obj, false)[attr];  
    } else {  
        return obj.currentStyle[attr];  
    }  
}

/**
 * 生成唯一 ID
 * @param {*} len  min 0
 * @param {*} radix max 16
 */
export const uuid = (len, radix) => {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    let uuid = [], i;
    radix = radix || chars.length;
    
    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix]
    } else {
     
        var r;
    
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        
        // Fill in random data. At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random()*16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
            }
        }
    }
    
    return uuid.join('');
}

export const layoutId = (prifix = 'M', len = 0, radix = 12) => {
    return [prifix, uuid(len, radix)].join('')
} 

/**
 * 导出
 */
export default {
    install(Vue, options) {
        Vue.prototype.$helper = {
            addComponent,
            batchExportComponents,
            bindEvent,
            bindEvents,
            css,
            getStyle,
            width,
            height,
            offset,
            scroll,
            uuid,
            layoutId
        }
    },
    addComponent,
    batchExportComponents,
    bindEvent,
    bindEvents,
    css,
    getStyle,
    width,
    height,
    offset,
    scroll,
    uuid,
    layoutId
}


// WEBPACK FOOTER //
// ./utils/helper.js